<template>
  <span>
    <items></items>
  </span>
</template>
<script>
import Items from '@/components/services/Items'
export default {
  name: 'Services',
  components: {
    Items
  }
}
</script>
<style scoped></style>
